import React, { useState } from 'react';
import './Navigation.css';
import logo from './logo.png';
import cartIcon from './cart.jpg'; // Import cart image

const Navigation = ({ scrollToSection, refs }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  // Close menu when clicking a nav item
  const handleNavClick = (ref) => {
    scrollToSection(ref);
    setIsMenuOpen(false); // Close menu after navigation
  };

  return (
    <nav className="navbar">
      <div className="logo">
        <img src={logo} alt="Sawla Stone Logo" />
      </div>

      {/* Menu Toggle for Mobile */}
      <button className="menu-toggle" onClick={toggleMenu}>
        {isMenuOpen ? '✖' : '☰'}
      </button>

      {/* Navigation Links */}
      <div className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
        <ul>
          <li><button onClick={() => handleNavClick(refs.homeRef)}>Home</button></li>
          <li><button onClick={() => handleNavClick(refs.aboutRef)}>About Us</button></li>
          <li><button onClick={() => handleNavClick(refs.galleryRef)}>Gallery</button></li>
          <li><button onClick={() => handleNavClick(refs.productRef)}>Products</button></li>
          <li><button onClick={() => handleNavClick(refs.contactRef)}>Contact</button></li>
          {/* Cart Icon in Mobile Drawer */}
          <li className="mobile-cart">
            <button onClick={() => handleNavClick(refs.cartRef)}>
              <img src={cartIcon} alt="Cart" className="cart-img" /> Cart <span className="cart-count">0</span>
            </button>
          </li>
        </ul>
      </div>

      {/* Cart Icon (Visible on Large Screens) */}
      <div className="nav-cart desktop-cart">
        <img src={cartIcon} alt="Cart" className="cart-img" />
        <span className="cart-count">0</span>
      </div>
    </nav>
  );
};

export default Navigation;
